import { useRef } from "react";
import { Spinner } from "../../../common/spinner";
import { useFinanceServices } from "./finance_services";
import { PaymentRecordList } from "./payment_records";
import { Pagination } from "../../../common/pagination";
import { GENERAL_PAGINATION_SIZE } from "../../../../lib/common/constants";

export const FinanceAdmin = () => {
    const { currentPage, paymentList, workingState, totalRows, getAllPaymentRecords, retryPaymentIntent, setCurrentPage } = useFinanceServices();

    const paymentListRef = useRef<HTMLDivElement>(null);

    const retryPaymentHandler = async (user_id: number) => {
        await retryPaymentIntent(user_id);
        getAllPaymentRecords(0);
    };

    return (
        <div className="row admin-section p-3 m-auto" ref={paymentListRef}>
            <div className="pb-2">
                <h4 className="text-secondary fw-bold ">Payment Records</h4>
                <p>
                    {" "}
                    <small>
                        Displays a list of all dental employers payments, including name, amount, payment method, date, concept, and status, with options to
                        view user profiles and retry failed payments.
                    </small>
                </p>
            </div>
            <div>
                {workingState === "working" && (
                    <div className="p-4 text-primary">
                        <Spinner spinnerColor="text-primary" />
                    </div>
                )}
                {workingState === "done" && paymentList.length > 0 && (
                    <>
                        <PaymentRecordList paymentList={paymentList} retryPaymentCallback={retryPaymentHandler} />
                        <div>
                            <Pagination
                                currentPage={currentPage}
                                totalCount={totalRows}
                                itemsPerPage={GENERAL_PAGINATION_SIZE}
                                refObject={paymentListRef}
                                onPageChange={(offset) => {
                                    getAllPaymentRecords(offset);
                                    setCurrentPage(offset + 1);
                                }}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
